import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionProvider } from '../../core/providers/session.provider';
import { AuthService } from '../../../api/services/auth.service';

/**
 * Ha a munkamenet lejárt (pl. a nyitva hagyott alkalmazásban 8 óránál régebbi a token), a backend 401-et ad.
 * Ilyenkor kiléptetjük a felhasználót, és bejelentkezés után visszavisszük az aktuális oldalra. (MIRA-2338)
 */
@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
    constructor(
        private session: SessionProvider,
        private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error) => {
                // a munkamenet ellenőrzését (AuthGuard) nem kezeljük itt, az maga intézi a kiléptetést
                if (error instanceof HttpErrorResponse && error.status === 401 &&
                    this.session.getToken() !== undefined && !request.url.endsWith(AuthService.CheckPath)) {
                    this.session.setRedirectUrl(this.router.url);
                    this.session.logout(true);
                }

                return throwError(() => error);
            })
        );
    }
}
